<ng-container>
  <lib-data-capture-heading id="ddHeader" [QnDescription]="qnData.qDescription"
    [QnSubDescription]="qnData.qSubDescription"></lib-data-capture-heading>
  <lib-drop-down id="appDropDown" class=".mb-1" [form]="dropdownForm" [field]="field"></lib-drop-down>

  <div class="next-btn-container">
    <lib-primary-button id="btnNext" [text]="nextBtn" (clicked)="submitDropdownAnswer()"
      [disabled]="!dropdownForm.valid" autofocus></lib-primary-button>
  </div>
</ng-container>